<template>
  <div class="d-flex align-items-center">
    <SwitchComponent :setValue.sync="setValue" @onChange="onChange" />
    <span class="ml-4 text-color-primary font-bold">Borrador / Publicar</span>
  </div>
</template>

<script>
import SwitchComponent from "../../../components/Switch";

export default {
  name: "SwitchStatus",
  methods: {
    onChange({ value }) {
      this.$emit("onStatus", { status: value });
    }
  },
  components: {
    SwitchComponent
  },
  props: {
    setValue: {
      default: false
    }
  }
};
</script>

<style></style>
